export default (lng: string) =>
	lng && lng.length === 2 ? `${lng[0].toUpperCase()}${lng[1].toLowerCase()}` : ''
